import ReactDOM from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  CloseButton,
  Container,
  Header,
  HeaderBar,
  Overlay,
  Listcontainer,
} from './ProductsList.styles';

interface IAddFieldContent {
  open: boolean;
  onClose: () => void;
  ContentList: () => JSX.Element;
}

const ProductsList = ({ open, onClose, ContentList }: IAddFieldContent) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDOM.createPortal(
        <Overlay>
          <Container>
            <HeaderBar>
              <Header>Relationships</Header>
              <CloseButton onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </HeaderBar>
            <Listcontainer>
              <ContentList />
            </Listcontainer>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};

export { ProductsList };
